import { ErrorResponse, RequestError } from '@utils/request/request.type';
import { ACCESS_TOKEN_KEY, PUBLIC_PAGE_TOKEN } from '@utils/token/constants';
import { getPublicPageToken } from '@utils/token/get-public-page-token';
import i18n from 'i18next';
import Cookies from 'js-cookie';
import fetch from 'unfetch';

export const request = async ({
  url,
  method,
  withCredentials,
  body,
  headers,
}: {
  url: string;
  method: string;
  withCredentials?: boolean;
  body?: unknown;
  headers?: Record<string, string>;
}) => {
  const token = Cookies.get(ACCESS_TOKEN_KEY as string);
  const sharedReportToken = getPublicPageToken(PUBLIC_PAGE_TOKEN);
  if (!token && method === 'GET' && !sharedReportToken)
    throw new RequestError({ message: 'prevent empty access token call', status: 401, code: 0 });
  const isBodyFormData = body instanceof FormData;
  const bodyParsed = body ? (isBodyFormData ? body : JSON.stringify(body)) : null;

  // Derive current language from i18n and normalize it to a base language code (e.g. "es-ES" -> "es").;
  const rawLanguage = i18n.language ?? i18n.resolvedLanguage ?? 'en';
  const normalizedLanguage = rawLanguage.split('-')[0];

  const options = {
    headers: {
      ...(!isBodyFormData && {
        'Content-Type': 'application/json',
      }),
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(sharedReportToken && { 'X-SHARED-REPORT-TOKEN': sharedReportToken }),
      ...(normalizedLanguage && { 'Accept-Language': normalizedLanguage }),
      // Allow per-request headers to override defaults when needed
      ...headers,
    },
    ...(withCredentials && { credentials: 'include' as const }),
    method,
    body: bodyParsed,
  };

  const response = await fetch(url, options);

  if (!response.ok) {
    const { error } = (await response.json()) as ErrorResponse;
    const { message, code } = error;
    throw new RequestError({ message, code, status: response.status });
  }

  if (response.status === 204) {
    return undefined;
  }

  const { data } = await response.json();
  return data;
};
